const isPlainObject = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" &&
	value !== null &&
	!Array.isArray(value) &&
	(Object.getPrototypeOf(value) === Object.prototype ||
		Object.getPrototypeOf(value) === null);

const hasDirtyField = (dirty: unknown): boolean => {
	if (Array.isArray(dirty)) return dirty.some(hasDirtyField);
	if (isPlainObject(dirty)) return Object.values(dirty).some(hasDirtyField);

	return dirty === true;
};

export const getFormValuesDiff = <TInput, TOutput>(
	dirtyFields: unknown,
	currentValues: TOutput,
): Partial<Pick<TOutput, keyof TInput & keyof TOutput>> => {
	if (!isPlainObject(dirtyFields)) return {};

	const result: Record<string, unknown> = {};
	const values = currentValues as Record<string, unknown>;

	for (const key of Object.keys(dirtyFields)) {
		const dirty = dirtyFields[key];
		const value = values?.[key];

		if (!hasDirtyField(dirty)) continue;

		if (isPlainObject(dirty) && isPlainObject(value)) {
			result[key] = getFormValuesDiff(dirty, value);
		} else {
			result[key] = value;
		}
	}

	return result as Partial<Pick<TOutput, keyof TInput & keyof TOutput>>;
};
